module.exports = __webpack_public_path__ + "img/logo-mini.0af5141a.png";